import { uiText, useUiLanguage } from '../../utils/uiTranslation';
import React from 'react';
import { useTranslation } from 'react-i18next';
import './LinkedInSetup.css';

export default function LinkedInSetupBanner({ hasAtsAccess, onConnect }) {
  useUiLanguage();
  const { t } = useTranslation('home');
  return (
    <aside className="linkedin-setup-banner">
      <span className="linkedin-setup-mark" aria-hidden="true">{uiText("in")}</span>
      <div className="linkedin-setup-banner-copy">
        <strong>{t('linkedIn.bannerTitle', 'Reach candidates on LinkedIn')}</strong>
        <p>{hasAtsAccess
          ? t('linkedIn.bannerDescription', 'Connect your company page to set up LinkedIn job posting.')
          : t('linkedIn.bannerFreeDescription', 'Add your company page now. LinkedIn job syncing is available with ATS.')}</p>
      </div>
      <button type="button" className="linkedin-setup-secondary" onClick={onConnect}>
        {t('linkedIn.connectPage', 'Connect LinkedIn')}
        <i className="fa-solid fa-arrow-up-right-from-square" aria-hidden="true" />
      </button>
    </aside>
  );
}
